import { useCallMatching } from "@hooks/useCallMatching";
import Spinner from "@components/ui/Spinner";
import Button from "@components/ui/Button";
import CallMatchingHeader from "@components/admin-call-matching/CallMatchingHeader";
import AppointmentsPanel from "@components/admin-call-matching/AppointmentsPanel";
import CallLogsPanel from "@components/admin-call-matching/CallLogsPanel";
import MatchConfirmModal from "@components/admin-call-matching/MatchConfirmModal";

export default function AdminCallMatching() {
  const {
    clinics,
    selectedClinicId,
    selectClinic,
    appointments,
    callLogs,
    loading,
    actionLoading,
    selectedAppointmentId,
    setSelectedAppointmentId,
    selectedCallLogId,
    setSelectedCallLogId,
    filter,
    setFilter,
    matchModalOpen,
    setMatchModalOpen,
    handleMatch,
    handleUnmatch,
    refresh,
  } = useCallMatching();

  const selectedAppointment = appointments.find(
    (a) => a.id === selectedAppointmentId
  );
  const selectedCallLog = callLogs.find((cl) => cl.id === selectedCallLogId);

  const canMatch = selectedAppointmentId && selectedCallLogId;

  return (
    <div className="p-4 sm:p-6 space-y-4">
      <CallMatchingHeader
        clinics={clinics}
        selectedClinicId={selectedClinicId}
        onSelectClinic={selectClinic}
        filter={filter}
        onFilterChange={setFilter}
        onRefresh={refresh}
        loading={loading}
      />

      {!selectedClinicId && (
        <div className="text-center py-12 text-gray-500 text-sm">
          Select a clinic to view call logs and appointments.
        </div>
      )}

      {selectedClinicId && loading && (
        <div className="flex justify-center py-12">
          <Spinner size="lg" />
        </div>
      )}

      {selectedClinicId && !loading && (
        <>
          {/* Split panel: Appointments (left) | Call Logs (right) */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <AppointmentsPanel
              appointments={appointments}
              selectedAppointmentId={selectedAppointmentId}
              onSelect={setSelectedAppointmentId}
              onUnmatch={handleUnmatch}
              actionLoading={actionLoading}
            />
            <CallLogsPanel
              callLogs={callLogs}
              selectedCallLogId={selectedCallLogId}
              onSelect={setSelectedCallLogId}
            />
          </div>

          {/* Match action bar */}
          <div className="flex justify-center">
            <Button
              disabled={!canMatch || actionLoading}
              onClick={() => setMatchModalOpen(true)}
            >
              Match Selected
            </Button>
          </div>
        </>
      )}

      <MatchConfirmModal
        show={matchModalOpen}
        onClose={() => setMatchModalOpen(false)}
        onConfirm={handleMatch}
        appointment={selectedAppointment}
        callLog={selectedCallLog}
        loading={actionLoading}
      />
    </div>
  );
}
